import React from 'react'
import { useSelector } from 'react-redux'
import { selectWhiteListStatus } from '../../../redux/personaliseLessons/whiteListSlice'

const BenefitsOfCourse = () => {

    const whiteListUserStatus = useSelector(selectWhiteListStatus)

    const notInWhiteListUser = whiteListUserStatus?.message === 'Email is not pre registered.'

    return (
        <div>
            <h2 className='text-2xl font-semibold mb-3'>Benefits Of This Course</h2>
            <div className='bg-[#2D4F71] p-3 rounded-xl'>
                <div className='flex items-center bg-[#1D3854] p-3 rounded-xl mb-3'>
                    <div className='w-[55px] h-[50px] mr-2'>
                        <img src="https://assets.learntube.ai/files/AI_Syllabus_generator/Project_management_4.svg?updatedAt=1685516333321" alt="" className='w-full h-full'/>
                    </div>
                    {notInWhiteListUser ? <p className='leading-5'>A stand-out portfolio with 4 new projects & a <span className='text-[#67CDEE] font-bold'>93% better resume</span></p> : <p className='leading-5'>A stand-out profile & a <span className='text-[#67CDEE] font-bold'>93% better resume</span></p>}
                </div>
                <div className='flex items-center bg-[#1D3854] p-3 rounded-xl mb-3'>
                    <div className='w-[60px] h-auto mr-2'>
                        <img src="https://assets.learntube.ai/files/AI_Syllabus_generator/Resume_3.svg?updatedAt=1685526433121" alt="" className='w-full h-full'/>
                    </div>
                    <p className='leading-5'><span className='text-[#67CDEE] font-bold'>3x higher chance of getting hired</span> with amazing skills & certification</p>
                </div>
                <div className='flex items-center bg-[#1D3854] p-3 rounded-xl'>
                    <div className='w-[50px] h-auto mr-3'>
                        <img src="https://assets.learntube.ai/files/AI_Syllabus_generator/Companies_1.svg?updatedAt=1685526534357" alt="" className='w-full h-full object-fill'/>
                    </div>
                    <p className='leading-5'>A chance to interview with our <span className='text-[#67CDEE] font-bold'>900+ hiring partners</span></p>
                </div>
            </div>
        </div>
    )
}

export default BenefitsOfCourse
